var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "color-alpha",
      on: {
        mousedown: function($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.selectAlpha($event)
        }
      }
    },
    [
      _c("canvas", { ref: "canvasAlpha" }),
      _vm._v(" "),
      _c("div", { staticClass: "slide", style: _vm.slideAlphaStyle })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }